<template>
  <v-dialog
    v-model="isModalOpen"
    :max-width="width"
    :persistent="persistent"
    scrollable
  >
    <v-card color="white" :height="height">
      <v-card-text class="pa-0 text-black" style="height: 100%">
        <div
          class="d-flex"
          :class="isMobileOrTablet ? 'flex-column' : 'flex-row'"
          style="height: 100%"
        >
          <!-- TABS -->
          <div
            class="d-flex flex-column elevation-1"
            :style="isMobileOrTablet ? { width: '100%' } : { width: '25%' }"
          >
            <div
              v-for="tab in tabs"
              :key="tab.id"
              :class="['tab', { 'tab--active': activeTab === tab.id }]"
              @click="activeTab = tab.id"
            >
              <p class="w-100 ma-0 pa-3">
                {{ tab.label }}
              </p>
            </div>
          </div>

          <!-- TAB CONTENT -->
          <div class="d-flex flex-column pa-3 gap-4 modal-content">
            <div class="d-flex flex-column align-center" :style="{ flex: 1 }">
              <!-- LOGO -->
              <iusa-logo class="pb-4" no-link width="100px" />

              <div class="border w-100 pa-2" :style="{ flex: 1 }">
                <!-- ICON, TITLE, SUBTITLE -->
                <div
                  class="d-flex flex-column align-center justify-center gap-1"
                >
                  <div class="d-flex align-center justify-center gap-2">
                    <v-icon
                      v-if="currentTabData.icon"
                      color="black"
                      size="30px"
                    >
                      {{ currentTabData.icon }}
                    </v-icon>
                    <p
                      class="ma-0 text-center text-subtitle-1 font-weight-medium"
                    >
                      {{ currentTabData.title }}
                    </p>
                  </div>
                  <p class="ma-0 text-center font-weight-light">
                    {{ currentTabData.subtitle }}
                  </p>
                </div>

                <v-divider v-if="currentTabData.title"></v-divider>
                <!-- TAB CONTENT SLOT -->
                <slot :name="activeTab" />
              </div>
            </div>

            <!-- ACTION BUTTONS -->
            <div class="d-flex align-center justify-end gap-2">
              <!-- PREPEND -->
              <slot name="actions-prepend" />

              <!-- CLOSE MODAL BUTTON -->
              <v-btn
                v-if="!hideCloseButton"
                :color="hasActions ? '' : '#e20809'"
                :dark="!hasActions"
                :elevation="0"
                :plain="hasActions"
                @click="closeModal"
              >
                {{ closeButtonText }}
              </v-btn>

              <!-- APPEND -->
              <slot name="actions" />
              <slot :name="`actions-${activeTab}`" />
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import IusaLogo from '../IusaLogo.vue';
  import screen from '@/mixins/screen';

  export default {
    name: 'TabsModal',
    components: { IusaLogo },
    mixins: [screen],
    props: {
      value: { type: Boolean, required: true },
      tabs: {
        type: Array,
        required: true,
        validator: (tabs) => tabs.every((t) => t.id && t.label),
      },
      initialTab: {
        type: String,
        default: null,
      },
      width: { type: [String, Number], default: '1050px' },
      height: { type: [String, Number], default: '600px' },
      persistent: Boolean,
      hideCloseButton: Boolean,
      closeButtonText: { type: String, default: 'Cerrar' },
    },
    data() {
      return {
        activeTab: this.initialTab ?? this.tabs[0]?.id,
      };
    },
    computed: {
      isModalOpen: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        },
      },
      currentTabData() {
        return this.tabs.find((t) => t.id === this.activeTab) || this.tabs[0];
      },
      hasActions() {
        return (
          !!this.$slots['actions'] || !!this.$slots[`actions-${this.activeTab}`]
        );
      },
    },
    watch: {
      initialTab(tab) {
        if (tab) this.activeTab = tab;
      },
    },
    methods: {
      closeModal() {
        this.activeTab = this.tabs[0]?.id;
        this.isModalOpen = false;
        this.$emit('close');
      },
    },
  };
</script>

<style scoped>
  .tab {
    align-items: center;
    background-color: #b80709;
    color: #f0f0f0;
    cursor: pointer;
    display: flex;
    flex: 1;
    font-weight: 600;
    transition: 0.2s;
  }

  .tab--active {
    background-color: #e20809;
    color: #ffffff;
    font-weight: 900;
    text-decoration: underline;
    text-decoration-thickness: 3px;
    text-underline-offset: 6px;
  }

  .close-button {
    background-color: #e20809;
    color: #ffffff;
  }
  .modal-content {
    flex: 1;
    gap: 16px;
    overflow-y: auto;
  }

  .modal-content::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .modal-content::-webkit-scrollbar-track {
    background: #ffffff;
    border-radius: 4px;
  }

  .modal-content::-webkit-scrollbar-thumb {
    background: #e4e4e7;
    border-radius: 4px;
  }

  .modal-content::-webkit-scrollbar-thumb:hover {
    background: #dadadc;
    cursor: pointer;
  }

  .modal-content::-webkit-scrollbar-corner {
    background: #ffffff;
  }
</style>
